<template>
  <v-card class="align-center py-3 item" flat tile>
    <img
      @click="$router.push(content.to)"
      class="d-block item-img"
      :src="files + content.img + '?resize=1&w=95'"
      width="100%"
    />

    <div class="item-caption">
      <div class="d-flex justify-space-between">
        <div class="text-body-1 font-weight-medium item-title">
          {{ content.title }}
        </div>

        <v-btn @click="remove" color="#7C7C7C" height="38px" width="38px" icon>
          <v-icon small>fas fa-trash</v-icon>
        </v-btn>
      </div>

      <template v-if="content.variant">
        <v-chip
          class="px-2 rounded-pill item-variant"
          color="primary"
          text-color="white"
          x-small
        >
          Variação: {{ content.variant.title }}
        </v-chip>
      </template>

      <div
        class="d-flex align-center justify-space-between"
        :class="{ 'mb-n2': content.observations }"
      >
        <div class="secondary--text text-body-1 font-weight-medium item-price">
          {{ content.price ? formatPrice(content.price) : "Sob Consulta" }}
        </div>

        <div class="d-flex align-center">
          <template v-if="content.observations">
            <div class="position-relative">
              <template v-if="content.observations">
                <v-tooltip
                  v-model="showObservation"
                  color="grey darken-4"
                  open-on-click
                  :open-on-focus="false"
                  :open-on-hover="false"
                  bottom
                >
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      v-click-outside="() => (showObservation = false)"
                      class="mr-1"
                      color="secondary"
                      height="30px"
                      width="30px"
                      icon
                    >
                      <v-icon size="18"> fa-comment-alt </v-icon>
                    </v-btn>
                  </template>

                  <span color="white"> {{ content.observations }} </span>
                </v-tooltip>
              </template>
            </div>
          </template>

          <div class="align-center justify-space-between rounded item-amount">
            <v-btn
              class="grey--text px-0"
              @click="decrement"
              :disabled="content.quant <= 1"
              color="white"
              min-width="0"
              height="20px"
              width="20px"
              depressed
              text
            >
              <v-icon size="10">fa-minus</v-icon>
            </v-btn>

            <div class="text-caption text-center">
              {{ content.quant }}
            </div>

            <v-btn
              class="primary--text px-0"
              @click="increment"
              color="white"
              min-width="0"
              height="20px"
              width="20px"
              text
            >
              <v-icon size="10">fas fa-plus</v-icon>
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import ShoppingCartItem from "../model/ShoppingCartItem";
import formatPrice from "../util/formatPrice";

export default {
  props: {
    content: {
      type: ShoppingCartItem,
      required: true,
    },
  },
  data: () => ({
    showObservation: false,
  }),
  methods: {
    increment() {
      this.content.increment();
    },
    decrement() {
      this.content.decrement();
    },
    remove() {
      this.$emit("remove");
    },
    formatPrice,
  },
};
</script>

<style lang="scss" scoped>
.item {
  border-bottom: 1px solid #f1f1f1;
  display: grid;
  gap: 0 16px;
  grid-template-columns: 85px auto;

  @media screen and (min-width: 960.001px) and (max-width: 1264px) {
    gap: 0 8px;
    grid-template-columns: 80px auto;
  }

  &-img {
    aspect-ratio: 1;
    border-radius: 4px !important;
    -o-object-fit: cover;
    object-fit: cover;
    -o-object-position: center;
    object-position: center;
  }

  &-title {
    -webkit-box-orient: vertical;
    box-orient: vertical;
    display: block;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    line-height: 1.3 !important;
    overflow: hidden;
    text-overflow: ellipsis;

    @media screen and (min-width: 960.001px) and (max-width: 1264px) {
      font-size: 12px !important;
      line-height: 1.4 !important;
    }
  }

  &-variant {
    height: 20px;
  }

  &-price {
    @media screen and (min-width: 960.001px) and (max-width: 1264px) {
      font-size: 12px !important;
      line-height: 1.2 !important;
    }
  }

  &-amount {
    border: 1px solid #e1e1e1;
    display: grid;
    gap: 0;
    grid-template-columns: 20px 30px 20px;
    width: 100%;
  }

  &-observations {
    grid-column: 1 / -1;
  }
}
</style>
